/**
 * Re-export to prevent massive changes
 * TODO: TECH DEBT, remove dependencies from this path in favor of class inside '@controls' module
 */
export { ControlListenerPlugin, ControlListenerPluginToken } from '@controls/model/control-listener-plugin';
export { StandardListenerPlugin } from '@controls/core/standard-listener-plugin-template';
